<template>
  <Toast />
  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded">
        <div
          class="rounded-full bg-white outline outline-black inline-flex justify-center items-center h-24 w-24 -mt-20">
          <i class="pi pi-question text-5xl"></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-6">{{ message.header }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex items-center gap-2 mt-6">
          <Button :label="message.rejectLabel" outlined @click="rejectCallback" class="w-32"></Button>
          <Button :label="message.acceptLabel" @click="acceptCallback" class="w-32"></Button>
        </div>
      </div>
    </template>
  </ConfirmDialog>
  <ModalBillOfMaterialDetail v-if="modalShowBillOfMaterialDetail" @closeModal="closeModal" :billOfMaterialDetail="selectedBillOfMaterialDetail" :parentItemId="$route.params?.id" />
  <IndexView />
  <div id="overlay" class="fixed inset-0 bg-black bg-opacity-30 z-30" :class="{ hidden: !isBlur }"></div>
  <ViewContainer>
    <section class="p-6">
      <PageTitle :title="`Bill Of Material: ${this.item?.code} - ${this.item?.name}`" />
      <div class="bg-white dark:bg-dark-900 w-full rounded-lg py-6 px-5 shadow-lg">
        <div id="table-header" class="mb-5 flex justify-between">
          <AddButton to_url="#" button_text="+ Tambah Resep" button_class="text-base py-2 font-medium"
            @click="showModal" />
        </div>
        <div class="overflow-x-auto">
          <div class="inline-block min-w-full align-middle">
            <div class="overflow-hidden shadow-lg rounded-lg">
              <TableComponent>
                <TableHead>
                  <TableRow>
                    <TableHeadCell>No</TableHeadCell>
                    <TableHeadCell>Kode</TableHeadCell>
                    <TableHeadCell>Nama</TableHeadCell>
                    <TableHeadCell>Qty</TableHeadCell>
                    <TableHeadCell>Satuan</TableHeadCell>
                    <TableHeadCell>Action</TableHeadCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow v-if="allBillOfMaterialDetails?.length == 0">
                    <TableCell colspan="5" customClass="text-center italic text-gray-400 dark:text-gray-500"
                      noTextColor>
                      Belum ada resep
                    </TableCell>
                  </TableRow>
                  <TableRow v-else v-for="(billOfMaterialDetail, index) in allBillOfMaterialDetails" :key="billOfMaterialDetail.id" :index="index"
                    isBody>
                    <TableCell>{{ index + 1 }}</TableCell>
                    <TableCell>{{ billOfMaterialDetail.item?.code }}</TableCell>
                    <TableCell>{{ billOfMaterialDetail.item?.name }}</TableCell>
                    <TableCell>{{ billOfMaterialDetail.qty }}</TableCell>
                    <TableCell>{{ billOfMaterialDetail.item?.unit?.name }}</TableCell>
                    <TableCell noTextColor customClass="text-gray-500 dark:text-gray-400 flex">
                      <button :id="'edit-data-' + billOfMaterialDetail.id" @click="editBillOfMaterialDetail(billOfMaterialDetail)"
                        class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <PencilSquareIcon class="h-4 w-4 group-hover:text-green-700" />
                      </button>
                      <button :id="'delete-data-' + billOfMaterialDetail.id" @click="deleteBillOfMaterialDetail(billOfMaterialDetail)"
                        class="border border-gray-400 hover:border-red-500 hover:bg-red-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                        <TrashIcon class="h-4 w-4 group-hover:text-red-700" />
                      </button>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </TableComponent>
            </div>
          </div>
        </div>
      </div>
    </section>
  </ViewContainer>
</template>

<script>
import IndexView from "@/views/IndexView.vue";
import PageTitle from "@/components/PageTitle.vue";
import AddButton from "@/components/buttons/AddButton.vue";
import ModalBillOfMaterialDetail from "@/components/modals/ModalBillOfMaterialDetail.vue";
import ViewContainer from "@/components/ViewContainer.vue";
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import { PencilSquareIcon, TrashIcon } from "@heroicons/vue/24/solid";
import { mapGetters, mapActions } from "vuex";
import { Button, ConfirmDialog, Toast } from "primevue";

export default {
  name: "CategoryItemView",
  components: {
    IndexView, PageTitle, AddButton, ModalBillOfMaterialDetail, ViewContainer, TableComponent, TableHead, TableRow, TableHeadCell, TableBody, TableCell, PencilSquareIcon, TrashIcon, ConfirmDialog, Button, Toast
  },
  data() {
    return {
      modalShowBillOfMaterialDetail: false,
      isBlur: false,
      selectedBillOfMaterialDetail: null,
      currentPage: 1,
      totalPages: 1,
      item: {},
      allBillOfMaterialDetails: [],
    }
  },
  computed: {
    // ...mapGetters('bill_of_material_details', ['allBillOfMaterialDetails']),
    ...mapGetters('item_categories', ['allItemCategories']),
  },
  created() {
    this.fetchSpecifiedItem();
    this.fetchBillOfMaterialDetails();
  },
  methods: {
    ...mapActions('bill_of_material_details', ['deleteBillOfMaterialDetailById','updateBillOfMaterialDetail']),
    async fetchSpecifiedItem() {
      const response = await this.$store.dispatch('items/fetchItemById', this.$route.params.id);
      this.item = response.data;
    },
    async fetchBillOfMaterialDetails() {
      const response = await this.$store.dispatch('bill_of_material_details/fetchBillOfMaterialDetails', { limit: 1000, parent_item_id: this.$route.params.id });
      if (response?.data) {
        this.allBillOfMaterialDetails = response.data;
      }
    },
    showModal() {
      this.modalShowBillOfMaterialDetail = true;
      this.isBlur = true;
      this.selectedBillOfMaterialDetail = null;
    },
    closeModal() {
      setTimeout(() => {
        this.modalShowBillOfMaterialDetail = false;
        this.isBlur = false;
        this.fetchBillOfMaterialDetails();
      }, 200);
    },
    editBillOfMaterialDetail(billOfMaterialDetail) {
      this.selectedBillOfMaterialDetail = billOfMaterialDetail;
      this.modalShowBillOfMaterialDetail = true;
      this.isBlur = true;
    },
    async deleteBillOfMaterialDetail(billOfMaterialDetail) {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menghapus resep?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: async () => {
          try {
            const response = await this.deleteBillOfMaterialDetailById(billOfMaterialDetail.id);
            console.log('response', response);
            this.fetchBillOfMaterialDetails();
            this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Berhasil menghapus resep.', life: 3000 });
          }
          catch (error) {
            console.error('Gagal menghapus resep.', error);
            this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Gagal menghapus resep.', life: 3000 });
          }
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Batal menghapus resep.', life: 3000 });
        }
      });
    },
  },
}
</script>